import React, { createContext, useContext } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { getTranslation, LANGS, DEFAULT_LANG } from "../i18n/translations";

const LangCtx = createContext({
  lang: DEFAULT_LANG, setLang: () => {}, t: (k) => k, langs: LANGS,
});

const VALID_CODES = LANGS.map((l) => l.code);

export function LanguageProvider({ children }) {
  const { lang: paramLang } = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  const lang = VALID_CODES.includes(paramLang) ? paramLang : DEFAULT_LANG;

  const t = (path) => getTranslation(lang, path);

  const setLang = (newLang) => {
    if (!VALID_CODES.includes(newLang) || newLang === lang) return;
    // Replace first /:lang segment with new lang, preserve rest of path + search + hash
    const parts = location.pathname.split("/").filter(Boolean);
    // parts[0] should be the lang code. If admin routes, do nothing.
    if (parts[0] === "admin") return;
    if (VALID_CODES.includes(parts[0])) parts[0] = newLang;
    else parts.unshift(newLang);
    navigate("/" + parts.join("/") + location.search + location.hash, { replace: false });
  };

  return (
    <LangCtx.Provider value={{ lang, setLang, t, langs: LANGS }}>
      {children}
    </LangCtx.Provider>
  );
}

export const useLang = () => useContext(LangCtx);

/** Build a language-prefixed URL path (skips admin). */
export function useLocalePath() {
  const { lang } = useLang();
  return (path = "/") => {
    if (path.startsWith("/admin")) return path;
    const clean = path.startsWith("/") ? path.slice(1) : path;
    return clean ? `/${lang}/${clean}` : `/${lang}`;
  };
}
